import React from 'react';

import { FormLabel, Stack, TextField } from '@mui/material';

interface Props {
  error?: boolean;
  helperText?: string;
  label: string;
  value?: number;
}

export default function PackageNumberField({ error, helperText, label, value }: Props) {
  return (
    <Stack spacing={1}>
      <FormLabel>{label}</FormLabel>
      <TextField
        type="number"
        value={value ?? ''}
        size="small"
        fullWidth
        disabled
        error={error}
        helperText={helperText}
        slotProps={{ formHelperText: { sx: { ml: 0 } }, htmlInput: { min: 0 } }}
      />
    </Stack>
  );
}
